import { add, Duration, startOfDay, sub } from 'date-fns';
import { StrictDateRange } from '../../commonUI/DateRangeFilterSelect/types';

/**
 * Calculate a date range that spans back n days from the end date
 * (default start of tomorrow, so that the date range covers all of today)
 *
 * @returns {StrictDateRange} The calculated date range with start and end dates
 */
export const relativeDateRange = (
  duration: Duration,
  end?: Date
): StrictDateRange => {
  if (!end) {
    const today = startOfDay(new Date());
    end = add(today, { days: 1 });
  }

  const start = sub(end, duration);

  return { start, end };
};
